const $ = require('jquery')

// ------------------------------------
// Get query string
// ------------------------------------
const queryString = {
  variables: {
    arrQuery: [],
    arrParamVal: [],
    hash: null,
    baseUrl: [ window.location.protocol, '//', window.location.host, window.location.pathname ].join(''),
    queryString: window.location.search,
    hashes: window.location.href.slice(window.location.href.indexOf('?') + 1).split('&'),
  },
  /**
   * @name Get - create array of objects for query string
   * @return {Array}
   */
  Get () {
    const _this = this
    const arrQuery = _this.variables.arrQuery
    let arrParamVal = _this.variables.arrParamVal
    let hash = _this.variables.hash
    const hashes = _this.variables.hashes

    if (_this.variables.queryString) {
      for (let i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=')
        const strParamsVals = hash[1]
        arrParamVal = strParamsVals.split(',')
        arrQuery[hash[0]] = arrParamVal
      }
    }

    return arrQuery
  },

  /**
   * [_Get description]
   * @param  {Object} key [description]
   * @return {String}     [description]
   */
  _Get (key) {
    $.query.get(key)
  },

  /**
   * @name Update
   * @param {Object} key - name key for query string
   * @param {String} value - value of key for query string
   * @param {Function} callback - some functions after query update
   */
  Update (key, value, callback) {
    this._change($.query.SET(key, value))
    callback && callback()
  },

  /**
   * @name Remove
   * @param {Object} key - name key for query string
   * @param {String} value - value of key for query string
   * @param {Function} callback - some functions after query update
   */
  Remove (key, value, callback) {
    this._change($.query.REMOVE(key, value))
    callback && callback()
  },

  ClearAll () {
    const baseUrl = this.variables.baseUrl
    $.query.empty()

    window.history.pushState(null, document.title, baseUrl)
  },

  /**
   * @name _change
   * @method
   * @param  {Fnction} _method - name of method for changing query string
   * @return {String}
   */
  _change (_method) {
    const qsObj = _method
    const baseUrl = this.variables.baseUrl
    const QueryStringBuilder = function() {
      const obj = qsObj.keys
      const parts = []
      for (const i in obj) {
        if (obj.hasOwnProperty(i)) {
          parts.push(`${i}=${obj[i]}`)
        }
      }
      return parts.join('&')
    }()
    const params = `?${QueryStringBuilder}`
    const UrlWithqueryString = baseUrl + params

    if (window.location.pathname !== '/') {
      window.history.replaceState(null, document.title, UrlWithqueryString)
    }

    return UrlWithqueryString
  },
}

module.exports = queryString



// WEBPACK FOOTER //
// ./src/modules/queryString.js